import { SEARCH_RECEIVE } from '../../constants';

const initialState = {
    searchData: null
};

export const search = (state = initialState, action) => {
    switch (action.type) {
        case SEARCH_RECEIVE:
            return {
                ...state,
                searchData: action.payload.searchData,
            };
        default:
            return state;
    }
};
